import { render, staticRenderFns } from "./DrawBtn.vue?vue&type=template&id=00fd0e62"
import script from "./DrawBtn.vue?vue&type=script&lang=js"
export * from "./DrawBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports